import SeasonHighsAPI from 'media-base-ui/utils/seasonHighsAPI';
import actionCreators from './actionCreators';

const fetchSeasonHighsGoalsForData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsGoalsForData());

    try {
        const data = await SeasonHighsAPI.fetchTeamSeasonHighsData({
            type:'goalsFor',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsGoalsForDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsGoalsForDataResponse(false, [], error))
    }
};

const fetchSeasonHighsShotsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsShotsData());

    try {
        const data = await SeasonHighsAPI.fetchTeamSeasonHighsData({
            type: 'shots',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsShotsDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsShotsDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPenaltyMinutesData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPenaltyMinutesData());

    try {
        const data = await SeasonHighsAPI.fetchTeamSeasonHighsData({
            type: 'penaltyInMinutes',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPenaltyMinutesDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPenaltyMinutesDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPowerplayGoalsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPowerplayGoalsData());

    try {
        const data = await SeasonHighsAPI.fetchTeamSeasonHighsData({
            type: 'powerplayGoalsFor',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPowerplayGoalsDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPowerplayGoalsDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPlayerGoalsForData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPlayerGoalsData());

    try {
        const data = await SeasonHighsAPI.fetchPlayerSeasonHighsData({
            type:'goals',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPlayerGoalsDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPlayerGoalsDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPlayerAssistsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPlayerAssistsData());

    try {
        const data = await SeasonHighsAPI.fetchPlayerSeasonHighsData({
            type: 'assists',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPlayerAssistsDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPlayerAssistsDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPlayerPointsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPlayerPointsData());

    try {
        const data = await SeasonHighsAPI.fetchPlayerSeasonHighsData({
            type: 'points',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPlayerPointsDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPlayerPointsDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPlayerPowerplayGoalsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPlayerPowerplayGoalsData());

    try {
        const data = await SeasonHighsAPI.fetchPlayerSeasonHighsData({
            type: 'powerplayGoals',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPlayerPowerplayGoalsDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPlayerPowerplayGoalsDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPlayerShotsData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPlayerShotsData());

    try {
        const data = await SeasonHighsAPI.fetchPlayerSeasonHighsData({
            type: 'shots',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPlayerShotsDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPlayerShotsDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPlayerPIMData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPlayerPIMData());

    try {
        const data = await SeasonHighsAPI.fetchPlayerSeasonHighsData({
            type: 'penaltyInMinutes',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPlayerPIMDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPlayerPIMDataResponse(false, [], error))
    }
};

const fetchSeasonHighsPlayerTOIData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsPlayerTOIData());

    try {
        const data = await SeasonHighsAPI.fetchPlayerSeasonHighsData({
            type: 'timeOnIceTotal',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsPlayerTOIDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsPlayerTOIDataResponse(false, [], error))
    }
};


const fetchSeasonHighsGoalieShotsAgainstData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsGoalieShotsAgainstData());

    try {
        const data = await SeasonHighsAPI.fetchGoalieSeasonHighsData({
            type: 'shotsAgainst',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsGoalieShotsAgainstDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsGoalieShotsAgainstDataResponse(false, [], error))
    }
};

const fetchSeasonHighsGoalieSavesData = (season, gameType) => async dispatch => {
    dispatch(actionCreators.requestSeasonHighsGoalieSavesData());

    try {
        const data = await SeasonHighsAPI.fetchGoalieSeasonHighsData({
            type: 'saves',
            season,
            gameType
        });

        dispatch(actionCreators.seasonHighsGoalieSavesDataResponse(true, data, season, gameType, null));
    } catch (error) {
        dispatch(actionCreators.seasonHighsGoalieSavesDataResponse(false, [], error))
    }
};
export default {
    fetchSeasonHighsGoalsForData,
    fetchSeasonHighsShotsData,
    fetchSeasonHighsPenaltyMinutesData,
    fetchSeasonHighsPowerplayGoalsData,

    fetchSeasonHighsPlayerGoalsForData,
    fetchSeasonHighsPlayerAssistsData,
    fetchSeasonHighsPlayerPointsData,
    fetchSeasonHighsPlayerPowerplayGoalsData,
    fetchSeasonHighsPlayerShotsData,
    fetchSeasonHighsPlayerPIMData,
    fetchSeasonHighsPlayerTOIData,

    fetchSeasonHighsGoalieShotsAgainstData,
    fetchSeasonHighsGoalieSavesData
}
